import NiceModal, { useModal } from "@ebay/nice-modal-react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useLayoutEffect } from "react";
import styles from "./modal.module.css";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { dontShowCompleteQuestions } from "../../services/memberService";
import { addValueToCookie, isValueInCookie } from "../../helpers/CookieHandler";

export type ActionModalProps = {
  headerTitle: string;
  contentTitle: string;
  onNext: any;
  onCancel: any;
  primaryButtonText: string;
  primaryButtonStyle?: React.CSSProperties;
  seconderyButtonText: string;
  showCloseButton: boolean;
  showSeconderyButton: boolean;
  isWelcomeModal?: boolean;
  isDeleteModal?: boolean;
  image?: string;
  id?: string;
};

const ActionModal = NiceModal.create(
  ({
    showCloseButton,
    showSeconderyButton,
    headerTitle,
    contentTitle,
    onNext,
    primaryButtonText,
    primaryButtonStyle,
    seconderyButtonText,
    isWelcomeModal,
    image,
    isDeleteModal,
    onCancel,
    id,
  }: ActionModalProps) => {
    const modal = useModal();
    const location = useLocation();
    const history = useHistory();
    const openModalHashStateId = `${location.pathname}${location.search}&popup=action`;

    const member = useSelector((state: RootState) => state.member);

    // useLayoutEffect(() => {
    //   const listen = history.listen(historyBack);
    //   if (modal.visible) {
    //     // window.history.pushState({ openModalHashStateId }, `${openModalHashStateId}`, `${openModalHashStateId}`)
    //   }
    //   return () => listen();
    // }, [modal.visible]);

    useLayoutEffect(() => {
      const listen = history.listen(historyBack);
      if (modal.visible) {
        // window.history.pushState({ openModalHashStateId }, `${openModalHashStateId}`, `${openModalHashStateId}`)
      }

      if (id && !isValueInCookie("_popUpCancelledId", id)) {
        addValueToCookie("_popUpCancelledId", id);
      }

      return () => listen();
    }, [modal.visible]);

    const historyBack = () => {
      modal.hide();
    };

    const handleModalToggle = () => {
      // history.goBack();
      modal.hide();
    };

    const handleSecondaryBtnClick = async () => {
      // history.goBack();
      modal.hide();
      if (isWelcomeModal) {
        await dontShowCompleteQuestions(member.memberCode);
      }
      if (isDeleteModal) {
        onCancel();
      }
    };

    const handleOnNext = () => {
      onNext();
    };

    const modalClose: any = {
      width: "37px",
      height: "37px",
      position: "absolute",
      right: "-10px",
      top: "-10px",
    };

    return (
      <>
        <div>
          <Dialog
            sx={{
              "& .MuiDialog-paper": isWelcomeModal
                ? {
                    borderRadius: "12px",
                    overflowY: "unset",
                    height: "80vh",
                    maxHeight: "700px",
                  }
                : {
                    borderRadius: "12px",
                    overflowY: "unset",
                    minWidth: "300px",
                  },
            }}
            open={modal.visible}
            onClose={handleModalToggle}
          >
            {showCloseButton ? (
              // <a style={modalClose} onClick={handleModalToggle}>
              //     <div>&times;</div>
              // </a>
              <a
                href="#"
                onClick={handleModalToggle}
                className="close_button w-inline-block"
                style={modalClose}
              >
                <img
                  src="assets/images/ic_top_close.svg"
                  loading="lazy"
                  alt=""
                  style={{ height: "17px" }}
                />
              </a>
            ) : null}

            <DialogTitle className={styles.modalHeader}>
              <div style={{ fontSize: "1.7rem" }}>
                <b>{headerTitle}</b>
              </div>
            </DialogTitle>
            {isWelcomeModal && (
              <div
                className="signup_pict"
                style={{ maxWidth: "180px", maxHeight: "180px" }}
              >
                <img
                  src="assets/images/success_pict.svg"
                  loading="lazy"
                  alt=""
                />
              </div>
            )}
            {image && (
              <div
                className="signup_pict"
                style={{ maxWidth: "180px", maxHeight: "240px" }}
              >
                <img
                  src={image}
                  loading="lazy"
                  alt=""
                  style={{ maxWidth: "180px", maxHeight: "240px" }}
                />
              </div>
            )}
            <DialogContent className={styles.modalContent}>
              {contentTitle}
            </DialogContent>
            <DialogActions style={{ display: "flex", flexDirection: "column" }}>
              <button
                onClick={handleOnNext}
                className="button_full w-button"
                style={primaryButtonStyle}
              >
                {primaryButtonText}
              </button>
              {showSeconderyButton ? (
                <a
                  href="#"
                  style={{ textDecoration: "underline", color: "black" }}
                  onClick={handleSecondaryBtnClick}
                  className=""
                >
                  {seconderyButtonText}
                </a>
              ) : null}
            </DialogActions>
          </Dialog>
        </div>
      </>
    );
  },
);

export default ActionModal;
